
import conseil from '../../assets/conseil.jpg'
import venteachat from '../../assets/conseil.jpg'

import costEstimation from '../../assets/finance.jpg'
import manpower from '../../assets/conseil.jpg'
import Materials from '../../assets/Materials-estim.jpg'
import hardwood from '../../assets/hardwood.jpeg'

import heater1 from '../../assets/portfolio/heater1.png'
import heater2 from '../../assets/portfolio/heater2.png'


import bath1 from '../../assets/portfolio/bath1.png'
import bath2 from '../../assets/portfolio/bath2.png'

import kitchen1 from '../../assets/portfolio/kitchen1.png'
import kitchen2 from '../../assets/portfolio/kitchen2.png'
import kitchen3 from '../../assets/portfolio/kitchen3.png'

import hardwood1 from '../../assets/portfolio/hardwood1.png'
import hardwood2 from '../../assets/portfolio/hardwood2.png'

import Painting1 from '../../assets/portfolio/paint1.jpeg'
import Painting2 from '../../assets/portfolio/paint2.jpeg'

import Plastering1 from '../../assets/portfolio/Plastering1.png'
import Plastering2 from '../../assets/portfolio/Plastering2.png'

import DoorsStep1 from '../../assets/portfolio/DoorsStep1.png'
import DoorsStep2 from '../../assets/portfolio/DoorsStep2.png'
import DoorsStep3 from '../../assets/portfolio/DoorsStep3.png'

import HoodCeiling1 from '../../assets/portfolio/HoodCeiling1.png'
import HoodCeiling2 from '../../assets/portfolio/HoodCeiling2.png'
import HoodCeiling3 from '../../assets/portfolio/HoodCeiling3.png'

import Deck1 from '../../assets/portfolio/Deck1.png'
import Deck2 from '../../assets/portfolio/Deck2.png'

const hardwoodData = [hardwood1,hardwood2]
const PaintingData = [Painting1,Painting2]
const PlasteringData = [Plastering1,Plastering2]
const BathroomData = [bath1,bath2]
const KitchenData = [kitchen1,kitchen2,kitchen3]
const DoorsStepData = [DoorsStep1,DoorsStep2,DoorsStep3]
const PatioData = [heater1,heater2]
const DeckData = [Deck1,Deck2]
const ScapingData = [heater1,heater2]
const heaterData = [heater1,heater2]
const HoodCeilingData = [HoodCeiling1,HoodCeiling2,HoodCeiling3]
const LightData = [heater1,heater2]

const data = [
  {
    id: 13,
    category: 'Assessment',
    image: manpower,
    title: 'Manpower',
    desc: 'we open you the door to highly skilled artisans',
    details:heaterData
  }
  ,
  {
    id: 14,
    category: 'Assessment',
    image: Materials,
    title: 'Materials',
    desc: 'We provide you with materials you need at a fair price',
    ddetails:heaterData
  }
  ,
  {
    id: 15,
    category: 'Assessment',
    image: costEstimation,
    title: 'Cost Estimation',
    desc: 'We estimate the costs and execution timeline for your project',
    details:heaterData
  },
  {
    id: 1,
    category: 'Indoor Renovation',
    image: hardwood2,
    title: 'Hard wood Flooring',
    desc: "We cleaned, waterprooffed and installed the hardwood",
    details:hardwoodData
  },
  {
    id: 2,
    category: 'Indoor Renovation',
    image: Painting2,
    title: 'Painting',
    desc: "Our painting skills blowed the client",
    details:PaintingData
  },
  {
    id: 3,
    category: 'Indoor Renovation',
    image: Plastering2,
    title: 'Plastering',
    desc: "Our plastering skills blowed the client",
    details:PlasteringData

  },
  {
    id: 4,
    category: 'Indoor Renovation',
    image: bath2,
    title: 'Bathroom',
    desc: "We cleaned, waterprooffed and installed",
    details:BathroomData
  },
  {
    id: 5,
    category: 'Indoor Renovation',
    image: kitchen3,
    title: 'Kitchen',
    desc: "Client wanted confortable kitchen and made it",
    details:KitchenData
  },
  {
    id: 11,
    category: 'Indoor Renovation',
    image: HoodCeiling3,
    title: 'Ceiling Repair',
    desc: 'We cleaned, waterprooffed and installed',
    details:HoodCeilingData
  },
  
  {
    id: 6,
    category: 'Yard Renovation',
    image: DoorsStep3,
    title: 'Doors steps Repair',
    desc:"Tight budget project but made client happy",
    details:DoorsStepData
  },
  // {
  //   id: 7,
  //   category: 'Yard Renovation',
  //   image: venteachat,
  //   title: 'Patio',
  //   desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus imperdiet, nulla et dictum interdum, nisi lorem egestas odio, vitae scelerisque enim ligula venenatis",
  //   details:PatioData
  // },
  {
    id: 8,
    category: 'Yard Renovation',
    image: Deck2,
    title: 'Deck Platform Repair',
    desc:"In this project, we made sure the platform is stable",
    details:DeckData
  },
  // {
  //   id: 9,
  //   category: 'Yard Renovation',
  //   image: venteachat,
  //   title: 'Land Scaping',
  //   desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus imperdiet, nulla et dictum interdum, nisi lorem egestas odio, vitae scelerisque enim ligula venenatis",
  //   details:ScapingData
  // },

  {
    id: 10,
    category: 'Electricity',
    image: heater2,
    title: 'Heater Replacement',
    desc: 'In this project, we made sure the power effectiveness is met',
    details:heaterData
  },
  // {
  //   id: 12,
  //   category: 'Electricity',
  //   image: conseil,
  //   title: 'Light Fixtures',
  //   desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus imperdiet, nulla et dictum interdum, nisi lorem egestas odio, vitae scelerisque enim ligula venenatis',
  //   details:LightData
  // },
  
  
]

export default data
